module.exports = __webpack_public_path__ + "static/media/photo309.2bab51dd.jpg";